<template>
    <div>
        <div class="compare">
          <div class="compareKey__btn" @click="openComparePanel">
            Key值比對
          </div>
        </div>
        <modal
            name="compareModal"
            :resizable="true"
            :styles="{ padding: '10px' }"
            >
            <textarea :placeholder="placeholderExample" :style="{ width: '100%', height: 'calc(100% - 60px)', resize: 'none' }" v-model="textInput" />
            <div v-if="outputData.length > 0">{{ `找到 ${outputData.length} 筆新資料` }}</div>
            <div class="control_row">
                <div class="compare__btn" @click="doCompare()" :class="{ disable: !checkInput }">
                比對
                </div>
                <div class="export__btn" @click="exportExcel()" :class="{ disable: !exportStatus }">
                輸出Excel
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'CompareKey',
    data() {
        return {
            textInput: '',
            outputData: []
        }
    },
    
    computed: {
        ...mapGetters(['sortedData', 'langs']),
        keyList() {
            return this.sortedData.map(item => item.key)
        },
        placeholderExample() {
            return `EX: ["台灣", "香港", "俄罗斯"]`
        },
        checkInput() {
            let _isParseValid = false
            const _bracketsValid = this.textInput.includes('[') && this.textInput.includes(']')
            try {
                _isParseValid = JSON.parse(this.textInput)
            } catch {
                return false
            }
            const _includeValue = _isParseValid && (JSON.parse(this.textInput)).length > 0
            return _bracketsValid && _includeValue
        },
        exportStatus() {
            return this.outputData.length
        }
    },
    methods: {
        reset() {
            this.textInput = ''
            this.outputData = []
        },
        openComparePanel() {
            this.reset()
            this.$modal.show('compareModal')
        },
        doCompare() {
            const inputList = JSON.parse(this.textInput)
            let output = []
            for(let item of inputList) {
                if (item.length !== 0 && this.keyList.indexOf(item) === -1) {
                    output.push({ key: item })
                }
            }
            this.outputData = output
        },
        exportExcel() {
            const xlsxHeader = ["key", ...this.langs]
            const workSheet = this.$xlsx.utils.json_to_sheet(
                this.outputData,
                { header: xlsxHeader }
            )
            const workbook = this.$xlsx.utils.book_new()
            this.$xlsx.utils.book_append_sheet(workbook, workSheet, "MySheet")
            this.$xlsx.writeFile(workbook, "translate-country-list.xlsx", { compression: true })
        }
    }
}
</script>
<style lang="scss" scoped>
.compare {
  display: flex;
  margin: 0.75rem 0;
  @media screen and (min-width: 768px) {
      margin: 1rem 0;
  }
  .compareKey__btn{
    background-color: #21ba45;
    color: #fff;
    box-shadow: 0 0 0 0 rgba(34,36,38,.15) inset;
    padding: 0.5rem 1.5rem;
    border-radius: 0.3rem;
    cursor: pointer;
    &:hover {
        background-color: #16ab39;
    }
  }
}
.control_row {
  display: flex;
  justify-content: center;
  align-items: center;
  .compare__btn, .export__btn {
    background-color: #21ba45;
    color: #fff;
    box-shadow: 0 0 0 0 rgba(34,36,38,.15) inset;
    cursor: pointer;
    padding: 5px 15%;
    margin: 0 10px;
    border-radius: 5px;
    &:hover {
      background-color: #16ab39;
    }
    &.disable {
        pointer-events: none;
        background-color: #eeeeee;
    }
  }
}
</style>